export enum QuartileRange {
	'One' = 0.25,
	'Two' = 0.5,
	'Three' = 0.75,
	'Four' = 1,
}

export type Quartile = 1 | 2 | 3 | 4;

type TotalInCents = number;
export type QuartileRanges = { [key in Quartile]: TotalInCents };
